import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CompaniesState } from '../../models/stock.model';

// Feature selector
export const selectCompaniesState = createFeatureSelector<CompaniesState>('stocks');

// Selectors for companies
export const selectAllCompanies = createSelector(
  selectCompaniesState,
  (state: CompaniesState) => state.companies
);

export const selectSelectedStock = createSelector(
  selectCompaniesState,
  (state: CompaniesState) => state.selectedStock
);

export const selectCompaniesLoading = createSelector(
  selectCompaniesState,
  (state: CompaniesState) => state.loading
);

export const selectStocksLoading = createSelector(
  selectCompaniesState,
  (state: CompaniesState) => state.loading
);

export const selectCompaniesError = createSelector(
  selectCompaniesState,
  (state: CompaniesState) => state.error
);

// Selectors for related entities
export const selectSectors = createSelector(
  selectCompaniesState,
  (state: CompaniesState) => state.sectors
);

export const selectMarkets = createSelector(
  selectCompaniesState,
  (state: CompaniesState) => state.markets
);

export const selectIndustries = createSelector(
  selectCompaniesState,
  (state: CompaniesState) => state.industries
);

export const selectTemplates = createSelector(
  selectCompaniesState,
  (state: CompaniesState) => state.templates
);

export const selectTemplateProperties = createSelector(
  selectCompaniesState,
  (state: CompaniesState) => state.templateProperties
);

// Pagination selector
export const selectPagination = createSelector(
  selectCompaniesState,
  (state: CompaniesState) => state.pagination
);

export const selectSettings = createSelector(selectCompaniesState, (state) => state.settings);

// Helper selector to get template properties by template ID and category
export const selectTemplatePropertiesByCategory = (templateId: string, category: string) =>
  createSelector(selectSettings, (settings) => {
    if (!settings || !settings.templates) return [];

    const template = settings.templates.find((t: any) => t.id === templateId);
    if (!template || !template.properties) return [];

    const categoryProperties = template.properties
      .filter((item: any) => item.category === category)
      .flatMap((item: any) => item.properties);

    return categoryProperties || [];
  });
